import { DocumentoComercialAsociadoReadingDtoProps } from "./DTOs/DocumentoComercialAsociadoReadingDto"
import { FacturaReadingDtoProps } from "./DTOs/FacturaReadingDto"
import { FacturaReadingFiltersDtoProps } from "./DTOs/FacturaReadingFiltersDto"
import { FacturaReadingSimpleDtoProps } from "./DTOs/FacturaReadingSimpleDto"
import { FicheroReadingDtoProps } from "./DTOs/FicheroReadingDto"
import { FlujoTesoreriaReadingDtoProps } from "./DTOs/FlujoTesoreriaReadingDto"
import { GetFacturaCarteraByFiltersDtoProps } from "./DTOs/GetFacturaCarteraByFiltersDto"
import { GetFacturasAceptablesDtoProps } from "./DTOs/GetFacturasAceptablesDto"
import { GetFacturasFinanciablesDtoProps } from "./DTOs/GetFacturasFinanciablesDto"
import { GetResumenContabilidadFacturaDto } from "./DTOs/GetResumenContabilidadFacturaDto"
import { ValidacionDocumentoReadingDtoProps } from "./DTOs/ValidacionDocumentoReadingDto"
import { GetFacturasConciliablesDtoProps } from "./Schemas/GetFacturasConciliablesDtoProps"

export const facturaByFilterAdapter = (
  factura: FacturaReadingFiltersDtoProps
): FacturaReadingFiltersDtoProps => {
  return {
    id: factura.id,
    divisa: factura.divisa,
    esBorrador: factura.esBorrador,
    estadoRevisionActual: factura.estadoRevisionActual,
    fechaEmision: factura.fechaEmision,
    importe: factura.importe,
    nifLibrado: factura.nifLibrado,
    nifLibrador: factura.nifLibrador,
    numero: factura.numero,
    origen: factura.origen,
    razonSocialLibrado: factura.razonSocialLibrado,
    razonSocialLibrador: factura.razonSocialLibrador,
    serie: factura.serie,
    tipoDocumento: factura.tipoDocumento,
    estadoPago: factura.estadoPago,
    estadoCobro: factura.estadoCobro,
    importePendiente: factura.importePendiente,
    estadoOperaciones: factura.estadoOperaciones,
    facturaProforma: factura.facturaProforma,
    facturaRectificada: factura.facturaRectificada,
    facturaRectificativa: factura.facturaRectificativa,
    puedeBorrarse: factura.puedeBorrarse,
  }
}

export const facturaFinanciableAdapter = (
  factura: GetFacturasFinanciablesDtoProps
): GetFacturasFinanciablesDtoProps => {
  return {
    divisa: factura.divisa,
    fechaEmision: factura.fechaEmision,
    importe: factura.importe,
    nif: factura.nif,
    numero: factura.numero,
    razonSocial: factura.razonSocial,
    id: factura.id,
  }
}

export const facturaAceptableAdapter = (
  factura: GetFacturasAceptablesDtoProps
): GetFacturasAceptablesDtoProps => {
  return {
    id: factura.id,
    estado: factura.estado,
    fechaEmision: factura.fechaEmision,
    idExterno: factura.idExterno,
    importe: factura.importe,
    librador: factura.librador,
    numero: factura.numero,
  }
}

export const adapterResumenFactura = (
  factura: GetResumenContabilidadFacturaDto
): GetResumenContabilidadFacturaDto => {
  return {
    cuentaContableId: factura.cuentaContableId,
    empresaCreadoraId: factura.empresaCreadoraId,
    fechaContabilizacion: factura.fechaContabilizacion,
    importe: factura.importe,
    impuestos: factura.impuestos,
    listadoTags: factura.listadoTags,
    retenciones: factura.retenciones,
    subtotal: factura.subtotal,
  }
}

export const adapterFacturaCartera = (
  factura: GetFacturaCarteraByFiltersDtoProps
): GetFacturaCarteraByFiltersDtoProps => {
  return {
    empresa: {
      id: factura?.empresa?.id,
      razonSocial: factura?.empresa?.razonSocial,
    },
    fecha: factura.fecha,
    fechaVencimiento: factura.fechaVencimiento,
    id: factura.id,
    importe: factura.importe,
    importePendiente: factura.importePendiente,
    numero: factura.numero,
  }
}

export const facturaByIdSimple = (
  factura: FacturaReadingSimpleDtoProps
): FacturaReadingSimpleDtoProps => {
  return {
    asientoContable: factura.asientoContable,
    id: factura.id,
    divisa: factura.divisa,
    empresa: factura.empresa,
    estadoRevisionActual: factura.estadoRevisionActual,
    fechaEmision: factura.fechaEmision,
    fechaVencimiento: factura.fechaVencimiento,
    importe: factura.importe,
    motivo: factura.motivo,
    serieNumero: factura.serieNumero,
    tipoDocumento: factura.tipoDocumento,
    estadoCobro: factura.estadoCobro,
    estadoPago: factura.estadoPago,
    facturaRectificada: factura.facturaRectificada,
    facturaRectificativa: factura.facturaRectificativa,
    importePendiente: factura.importePendiente,
    puedeBorrarse: factura.puedeBorrarse,
    tipoFlujoTesoreria: factura.tipoFlujoTesoreria,
  }
}

export const facturaDocAsociadosAdapter = (
  doc: DocumentoComercialAsociadoReadingDtoProps
): DocumentoComercialAsociadoReadingDtoProps => ({
  id: doc?.id,
  numero: doc?.numero,
  serie: doc?.serie,
  tipoDocumento: doc?.tipoDocumento,
})

export const facturaFicherosAdjuntosAdapter = (
  archivo: FicheroReadingDtoProps
): FicheroReadingDtoProps => ({
  id: archivo.id,
  esDocumentoImportado: archivo.esDocumentoImportado,
  extension: archivo.extension,
  mediaType: archivo.mediaType,
  nombre: archivo.nombre,
  ruta: archivo.ruta,
  tamañoEnBytes: archivo.tamañoEnBytes,
  tipo: archivo.tipo,
})

export const facturaById = (
  factura: FacturaReadingDtoProps
): FacturaReadingDtoProps => {
  return {
    id: factura.id,
    estadoRevisionActual: factura.estadoRevisionActual,
    tipoDocumento: factura.tipoDocumento,
    adjuntos: factura.adjuntos,
    configuracion: factura.configuracion,
    articuloDocumentos: factura.articuloDocumentos,
    cliente: factura.cliente,
    descuento: factura.descuento,
    diasPago: factura.diasPago,
    divisa: factura.divisa,
    documentosAjustesPorDefecto: factura.documentosAjustesPorDefecto,
    documentosComercialesAsociados: factura.documentosComercialesAsociados,
    fechaEmision: factura.fechaEmision,
    fechaOperacion: factura.fechaOperacion,
    formaPago: factura.formaPago,
    importe: factura.importe,
    impuestoRetenido: factura.impuestoRetenido,
    libradoId: factura.libradoId,
    libradorId: factura.libradorId,
    logo: factura.logo,
    numero: factura.numero,
    numeroAdjuntos: factura.numeroAdjuntos,
    observaciones: factura.observaciones,
    origen: factura.origen,
    serie: factura.serie,
    tarifaImpuesto: factura.tarifaImpuesto,
    tipoDocumentoComercial: factura.tipoDocumentoComercial,
    totalRetenido: factura.totalRetenido,
    usuario: factura.usuario,
    cuentaContable: factura.cuentaContable,
    cuentaContableCategoriaId: factura.cuentaContableCategoriaId,
    estadoPago: factura.estadoPago,
    facturaRectificada: factura.facturaRectificada,
  }
}

export const getFacturasConciliablesAdapter = (
  factura: GetFacturasConciliablesDtoProps
): GetFacturasConciliablesDtoProps => ({
  id: factura?.id,
  descripcion: factura?.descripcion,
  fecha: factura?.fecha,
  identificador: factura?.identificador,
  importe: factura?.importe,
  empresa: factura?.empresa,
  tipo: factura?.tipo,
})

export const getFlujoTesoreriaFacturaAdapter = (
  flujoTesoreria: FlujoTesoreriaReadingDtoProps
): FlujoTesoreriaReadingDtoProps => ({
  id: flujoTesoreria.id,
  cuentaBancariaId: flujoTesoreria.cuentaBancariaId,
  descripcion: flujoTesoreria.descripcion,
  empresaId: flujoTesoreria.empresaId,
  fecha: flujoTesoreria.fecha,
  importe: flujoTesoreria.importe,
  razonSocial: flujoTesoreria.razonSocial,
  remesaId: flujoTesoreria.remesaId,
  tipo: flujoTesoreria.tipo,
  tipoRemesable: flujoTesoreria.tipoRemesable,
})

export const facturaDocumentoPendienteValidacionAdapter = (
  documento: ValidacionDocumentoReadingDtoProps
): ValidacionDocumentoReadingDtoProps => ({
  id: documento.id,
  autovalidacion: documento.autovalidacion,
  etapas: documento.etapas,
  rango: documento.rango,
  tipoDocumento: documento.tipoDocumento,
  todosLosRangos: documento.todosLosRangos,
})
